// src/pages/AssemblyStatus/components/ReadyForDepartureStatus.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Table, Pagination } from "antd";
import OrderStatusFullInfo from "./OrderStatusFullInfo";
import { fetchStatuses } from "../utils/fetch";
import {
  getOrderStatusDataSource,
  orderStatusColumnsReadyForDeparture,
} from "../utils/table";

const ReadyForDepartureStatus = ({ userPermission, query = "" }) => {
  const [leads, setLeads] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [totalCount, setTotalCount] = useState(0);

  const loadData = useCallback(
    (page = 1, size = limit) => {
      setIsLoading(true);
      setLeads([]);
      return fetchStatuses(
        "ACTIVE",                // state
        "READY_FOR_SHIPMENT",    // status
        query,
        setLeads,
        setIsLoading,
        setTotalCount,
        page,
        size
      ).then(({ currentPage: cp }) => {
        setCurrentPage(cp);
        setLimit(size);
      });
    },
    [query, limit]
  );

  useEffect(() => {
    loadData(1, limit);
  }, [query, loadData, limit]);

  const handlePageChange = (page, size) => {
    loadData(page, size);
  };

  return (
    <>
      <Table
        style={{ minWidth: 1000 }}
        size="small"
        bordered
        loading={isLoading}
        columns={orderStatusColumnsReadyForDeparture}
        dataSource={getOrderStatusDataSource(leads, loadData)}
        pagination={false}
        expandable={{
          expandedRowRender: (record) => (
            <OrderStatusFullInfo
              data={record.data}
              userPermission={userPermission}
              status={record.data.status}
            />
          ),
        }}
      />
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={currentPage}
          total={totalCount}
          pageSize={limit}
          showSizeChanger
          onChange={handlePageChange}
          onShowSizeChange={handlePageChange}
        />
      </div>
    </>
  );
};

export default ReadyForDepartureStatus;
